import { OutOfPageTypes, type AdType } from '@/modules/adv/types'

import type { HbBidderConfig } from '../types'

const BANNER_PLC = '10000733255'
const VIDEO_PLC = '10000733258'

const VIDEO_AD_TYPES = new Set<AdType>(OutOfPageTypes)

export const INMOBI: HbBidderConfig = {
    bidder: 'inmobi',
    params: ({ type }) => ({
        plc: VIDEO_AD_TYPES.has(type) ? VIDEO_PLC : BANNER_PLC,
    }),
}
